import React, { useEffect, useState } from "react";

export default function PhotoInput({
  token,
  jobId,
  activityId,
  value,
  onChange,
}) {
  const [photoUrl, setPhotoUrl] = useState(value?.filePath || null);
  const [uploading, setUploading] = useState(false);

  // 🔄 Sincronizar foto al recargar la vista
  useEffect(() => {
    setPhotoUrl(value?.filePath || null);
  }, [value]);

  /* 📤 Simular subida (hasta que tengas el endpoint real) */
  const uploadFile = async (file) => {
    setUploading(true);

    try {
      const simulatedUrl = URL.createObjectURL(file);

      setPhotoUrl(simulatedUrl);

      onChange({
        filePath: simulatedUrl,
        fileType: file.type,
      });
    } catch (err) {
      console.error("Error uploading file:", err);
      alert("Error subiendo la imagen");
    }

    setUploading(false);
  };

  /* 📸 Manejo selección archivo */
  const handleFileSelected = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    uploadFile(file);
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm space-y-4">

      {/* TITULO */}
      <p className="text-sm font-semibold text-darkBrown">
        📸 Evidencia fotográfica
      </p>

      {/* BOTONES ESTILO PRODSYNC */}
      <div className="flex gap-3">

        {/* Archivos */}
        <label className="flex-1 cursor-pointer">
          <div className="w-full px-4 py-2 rounded-md text-center 
                          bg-brickRed text-white font-medium
                          hover:bg-brickRedHover transition">
            📁 Seleccionar foto
          </div>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileSelected}
            className="hidden"
          />
        </label>

        {/* Cámara (solo móviles) */}
        <label className="flex-1 cursor-pointer">
          <div className="w-full px-4 py-2 rounded-md text-center 
                          bg-darkBrown text-white font-medium
                          hover:bg-darkBrownHover transition">
            📷 Cámara
          </div>
          <input
            type="file"
            accept="image/*"
            capture="environment"
            onChange={handleFileSelected}
            className="hidden"
          />
        </label>
      </div>

      {/* LOADER */}
      {uploading && (
        <div className="text-center text-gray-500">Subiendo imagen...</div>
      )}

      {/* PREVIEW */}
      {!uploading && photoUrl && (
        <div className="w-full">
          <img
            src={photoUrl}
            alt="Evidencia"
            className="rounded-lg border border-gray-300 w-full max-w-md 
                       shadow-sm object-cover"
          />
        </div>
      )}
    </div>
  );
}
